'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * @param {Map|Object} dataMap
 * @param {Object} opts
 */

function genReverser(dataMap) {
  var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var store = new Map();

  var defVal = opts.defaultValue;
  var reverseKey = opts.reverseKey;
  var key = opts.key;

  if (dataMap instanceof Map) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = dataMap.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2);

        var _key = _step$value[0];
        var val = _step$value[1];

        store.set(_key, val);
        store.set(val, _key);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else if (Array.isArray(dataMap)) {
    if (!key || !reverseKey) {
      throw new Error('key and reverseKey are required for Array dataMap');
    }

    dataMap.forEach(function (obj) {
      store.set(obj[key], obj[reverseKey]);
      store.set(obj[reverseKey], obj[key]);
    });
  } else {
    Object.keys(dataMap).forEach(function (key) {
      store.set(key, dataMap[key]);
      store.set(dataMap[key], key);
    });
  }

  /**
   * @param {String|Number} key
   */
  return function (key) {
    return store.get(key) || defVal;
  };
}

exports.default = genReverser;